<div class="loginbg">
  <div class="plblogin">
    <!-- CONTENT AREA START HERE -->
    <div id="loginboxlogic">
      <router-outlet></router-outlet>
    </div>
    <!-- CONTENT AREA END HERE -->
  </div>
</div>
